import '../../../jquery-ui.min'
import initSettingModal from '../modal.js'
import { fetchUsers } from '../../api/fetch'

$(document).on('turbolinks:load', () => {
  initModal()
  initSettingUsersPage()
})

const initModal = () => {
  const {
    onClickOpenCreateModal,
    onClickOpenEditModals,
    onClickOpenDeleteModals,
    onClickCloseModal,
    onClickCloseDeleteModal,
  } = initSettingModal({target: 'user'})

  onClickOpenCreateModal()
  onClickOpenEditModals()
  onClickOpenDeleteModals()
  onClickCloseModal()
  onClickCloseDeleteModal()
  initUserSearch()
}

const initSettingUsersPage = () => {
  onChangeResetAnotherSelector()
  changeUserAvatar()
}

const onChangeResetAnotherSelector = () => {
  const brandSelector = $('#brand_id')
  const shopSelector = $('#shop_id')

  brandSelector.on('click', () => {
    shopSelector.prop("selectedIndex", 0)
  })

  shopSelector.on('click', () => {
    brandSelector.prop("selectedIndex", 0)
  })
}

const changeUserAvatar = () => {
  $('.user-avatar input[name="user[avatar]"]').on('change', (event) => {
    const file = event.target.files[0]
    if (!file) {
      return
    }
    const parent = $(event.target).closest('.user-avatar')
    const area = parent.find('.m-frmProfile__img')
    const clear = parent.find('.m-frmProfile__delete')
    const reader = new FileReader()
    reader.onload = (event) => {
      let image = area.find('img')
      if (!image.length) {
        image = $('<img>')
        area.append(image)
      }
      image.attr('src', event.target.result)
      clear.css('display', '')
    }
    reader.readAsDataURL(file)
  })

  $('.user-avatar .m-frmProfile__delete').on('click', (event) => {
    const clear = $(event.currentTarget)
    const parent = clear.closest('.user-avatar')
    parent.find('.m-frmProfile__img').empty()
    parent.find('input[name="user[avatar]"]').val(null)
    parent.find('input[name="user[delete_avatar]"]').val(true)
    clear.css('display', 'none')
  })
}

const initUserSearch = () => {
  $("#userName,#userEmail").autocomplete({
    source: searchUsers,
    autoFocus: true,
    delay: 750,
    select: selectUser,
  })
}

const searchUsers = async (req, res) => {
  $('#sumasate_notes').hide();
  const users = await fetchUsers(req.term)
  const user_names = users.map((user) => `${user[0]} ${user[1]}`)
  res(user_names)
}

const selectUser = (e, ui) => {
  const userInfo = ui.item.value.split(' ')
  $('#userName').val(userInfo[0])
  $('#userEmail').val(userInfo[1])
  $('#sumasate_notes').show();
  return false;
}
